import { createReducer, on } from '@ngrx/store';
import * as AlbumsActions from './albums.actions';
import { initialAlbumsState } from './albums.state';

export const albumsReducer = createReducer(
  initialAlbumsState,

  on(AlbumsActions.loadAlbums, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.loadAlbumsSuccess, (state, { response }) => ({
    ...state,
    albums: response.items,
    pagination: {
      total: response.total,
      page: response.page,
      limit: response.limit,
      totalPages: response.totalPages,
    },
    loading: false,
    error: null,
  })),

  on(AlbumsActions.loadAlbumsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.loadAlbum, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.loadAlbumSuccess, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a).concat(
      state.albums.find(a => a.id === album.id) ? [] : [ album ],
    ),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.loadAlbumFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.createAlbum, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.createAlbumSuccess, (state, { album }) => ({
    ...state,
    albums: [ ...state.albums, album ],
    loading: false,
    error: null,
  })),

  on(AlbumsActions.createAlbumFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.updateAlbum, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.updateAlbumSuccess, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.updateAlbumFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.deleteAlbum, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.deleteAlbumSuccess, (state, { id }) => ({
    ...state,
    albums: state.albums.filter(a => a.id !== id),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.deleteAlbumFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.uploadPhotos, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.uploadPhotoSuccess, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a),
  })),

  on(AlbumsActions.uploadPhotosComplete, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.uploadPhotosFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.deletePhoto, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.deletePhotoSuccess, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.deletePhotoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AlbumsActions.setTitlePhoto, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AlbumsActions.setTitlePhotoSuccess, (state, { album }) => ({
    ...state,
    albums: state.albums.map(a => a.id === album.id ? album : a),
    loading: false,
    error: null,
  })),

  on(AlbumsActions.setTitlePhotoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

